import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Footer from '../components/Footer';

const careHomes = [
  {
    name: 'Care home 1',
    image: '/assets/images/care1.jpeg',
    comingSoon: false
  },
  {
    name: 'Care home 2',
    image: '/assets/images/care2.jpeg',
    comingSoon: true
  },
  {
    name: 'Care home 3',
    image: '/assets/images/care3.jpeg',
    comingSoon: true
  }
];

// Gallery shown when a home is clicked
const galleryImages = [
  '/assets/images/1.jpeg',
  '/assets/images/2.jpeg',
  '/assets/images/3.jpeg'
];

const CareHomes = () => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openGallery = () => {
    setCurrentIndex(0);
    setIsGalleryOpen(true);
  };

  const closeModal = () => setIsGalleryOpen(false);

  const goNext = () => setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
  const goPrev = () => setCurrentIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);

  return (
    <div className="CareHomes bg-white">
      <Header />
      <div className="mt-32 sm:mt-36 lg:mt-32">
        <Hero
          image="/assets/images/Our%20Homes.jpg"
          heightClass="min-h-[45vh] sm:min-h-[55vh] lg:min-h-[65vh]"
          overlay
        />

        <section className="py-14 sm:py-16 px-4 sm:px-6 lg:px-10" style={{ backgroundColor: '#f2f4f7' }}>
          <div className="max-w-6xl mx-auto space-y-8">
            <div className="space-y-3">
              <p className="text-sm uppercase tracking-[0.3em] text-[#2f4c74]">Care Homes</p>
              <h2 className="text-3xl sm:text-4xl font-light text-[#2b3d57]">Our residential portfolio</h2>
              <p className="text-base sm:text-lg text-[#2b3d57] max-w-4xl">
                A dedicated page for our residential settings with key information, images, and contact details for each home.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {careHomes.map((home) => (
                <figure
                  key={home.name}
                  className="bg-white rounded-2xl shadow-[0_18px_45px_rgba(15,23,42,0.08)] border border-[#e2e8f0] overflow-hidden"
                >
                  <button
                    type="button"
                    className="block w-full relative"
                    onClick={openGallery}
                    aria-label={`Open gallery for ${home.name}`}
                  >
                    <img
                      src={home.image}
                      alt={home.name}
                      className="h-56 w-full object-cover sm:h-64"
                    />
                    {home.comingSoon && (
                      <span className="absolute inset-0 flex items-center justify-center bg-black/45 text-white text-sm sm:text-base font-semibold tracking-[0.35em] uppercase">
                        Coming Soon
                      </span>
                    )}
                  </button>
                  <figcaption className="px-5 py-4 text-center text-sm font-semibold tracking-[0.2em] uppercase text-[#2f4c74]">
                    Click to see gallery
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>

        <Footer />
      </div>

      {isGalleryOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4 py-10"
          role="dialog"
          aria-modal="true"
          aria-label="Care home gallery"
          onClick={closeModal}
        >
          <div
            className="relative w-full max-w-5xl"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              onClick={closeModal}
              className="absolute -top-10 right-0 text-white text-2xl font-semibold tracking-[0.2em]"
              aria-label="Close gallery"
            >
              X
            </button>
            <div className="bg-white rounded-xl shadow-xl overflow-hidden">
              <img
                src={galleryImages[currentIndex]}
                alt={`Care home view ${currentIndex + 1}`}
                className="w-full max-h-[80vh] object-contain bg-black"
              />
              <div className="flex items-center justify-between px-6 py-4 text-[#2f4c74]">
                <button
                  type="button"
                  onClick={goPrev}
                  className="text-sm font-semibold tracking-[0.25em] uppercase"
                  aria-label="Previous image"
                >
                  ◀ Prev
                </button>
                <span className="text-sm font-medium tracking-[0.2em] uppercase">
                  {currentIndex + 1} / {galleryImages.length}
                </span>
                <button
                  type="button"
                  onClick={goNext}
                  className="text-sm font-semibold tracking-[0.25em] uppercase"
                  aria-label="Next image"
                >
                  Next ▶
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CareHomes;
